import script from "./ModalContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalContainer.vue?vue&type=script&setup=true&lang=js"

import "./ModalContainer.vue?vue&type=style&index=0&id=67034856&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67034856"]])

export default __exports__